import { FormControl, Validators } from '@angular/forms';
import { EoFormPanelConfig, EoInputConfig } from 'ngx-eo-web-components';

export const submitButtonLabel = 'Είσοδος στην Υπηρεσία';

const authFormConfig = new EoFormPanelConfig({
  header: '',
  headerStyleClass: 'mx-2 mb-0',
  name: 'login',
  // panelContentStyleClass: 'grid',
  config: [
    new EoInputConfig({
      name: 'username',
      styleClass: 'col-12',
      type: 'text',
      label: 'Όνομα Χρήστη',
      control: new FormControl('', [Validators.required]),
      errors: {
        required: 'Το όνομα χρήστη είναι υποχρεωτικό',
      },
    }),
    new EoInputConfig({
      name: 'password',
      styleClass: 'col-12',
      type: 'password',
      label: 'Κωδικός',
      control: new FormControl('', [Validators.required]),
      errors: {
        required: 'Ο κωδικός είναι υποχρεωτικός',
      },
    })
  ],
});

export const authorisationFormConfig: EoFormPanelConfig[] = [authFormConfig];
